import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import dayjs, { utc } from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { ButtonCopyNumber } from "../../../../components/ButtonCopyNumber/ButtonCopyNumber";
import { BsFillEyeFill } from "react-icons/bs";
import { MdDeleteOutline } from "react-icons/md";
import candidates from "../../../../services/candidates";
import ErrorToastHandler from "../../../../util/ErrorToastHandler";

dayjs.extend(advancedFormat);
dayjs.extend(utc);

const ETAPA_LABELS = {
  "1":  "Candidatura",
  "2":  "Triagem de Currículo",
  "3":  "Testes Psicológicos",
  "4":  "Prova de Conhecimento",
  "5":  "Dinâmica de Grupo",
  "6":  "Entrevista Dirigida",
  "7":  "Entrevista Livre",
  "8":  "Apresentação ao Gestor",
  "9":  "Exames Admissionais",
  "10": "Contratação",
};

const PERFIL_MAP = [
  { label: "Águia",   img: "aguia.jpg"   },
  { label: "Tubarão", img: "tubarao.jpg" },
  { label: "Gato",    img: "gato.png"    },
  { label: "Lobo",    img: "lobo.png"    },
];

const ASSETS_BASE = "https://assets.aprincipalbb.com.br/vagas";

function getDominantPerfil(perfilJson) {
  try {
    if (!perfilJson || !perfilJson.length) return null;
    let max = -1;
    let result = null;
    perfilJson.forEach((item, i) => {
      const pct = Number(item.porcentagem);
      if (pct > max) {
        max = pct;
        result = PERFIL_MAP[i] || null;
      }
    });
    return result;
  } catch (e) {
    console.log(perfilJson);
    
    console.log({ e });
    return null;
  }
}

export function RowsCandidate(props) {
  const { row, onDelete } = props;
  const params = useParams();
  const history = useHistory();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleId = (e) => {
    e.preventDefault();
    history.push(`/rh/vagas/ver-candidatos/${params.id}/${row.id}`);
  };

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await candidates.delete(row.id);
      setConfirmOpen(false);
      onDelete?.();
    } catch (error) {
      new ErrorToastHandler(error).showErrorToast();
    } finally {
      setDeleting(false);
    }
  };

  const etapaPct = row.etapa ? Number(row.etapa) * 10 : 0;
  const perfil = PERFIL_MAP[row.perfil_dominante] ?? getDominantPerfil(row.perfil);
  // console.log(perfil, row);

  return (
    <>
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Excluir candidato</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deseja excluir <strong>{row.nome}</strong>? Essa ação não pode ser desfeita.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} disabled={deleting}>
            Cancelar
          </Button>
          <Button onClick={handleDelete} color="error" disabled={deleting}>
            Excluir
          </Button>
        </DialogActions>
      </Dialog>
      <TableRow>
        <TableCell>
          <Typography
            color={"GrayText"}
            onClick={handleId}
            href={`/rh/vagas/ver-candidatos/${params.id}/${row.id}`}
            component={"a"}
          >
            <BsFillEyeFill fontSize={"25px"} />
          </Typography>
        </TableCell>

        <TableCell>
          {perfil ? (
            <Tooltip title={perfil.label}>
              <img
                src={`${ASSETS_BASE}/${perfil.img}`}
                alt={perfil.label}
                style={{ width: 40, height: 40, objectFit: "contain" }}
              />
            </Tooltip>
          ) : (
            <Typography variant="caption" color="text.secondary">—</Typography>
          )}
        </TableCell>

        <TableCell sx={{ whiteSpace: "nowrap" }}>{row.nome}</TableCell>

        <TableCell>
          <ButtonCopyNumber phone={row.telefone} />
        </TableCell>

        <TableCell>{row.escolaridade}</TableCell>

        <TableCell sx={{ minWidth: "120px" }}>
          <Typography variant="caption" display="block" fontStyle="italic">
            {ETAPA_LABELS[String(row.etapa)] || "—"}
          </Typography>
          <LinearProgress variant="determinate" value={etapaPct} />
          <Typography variant="caption">{etapaPct}%</Typography>
        </TableCell>

        <TableCell>
          <Typography minWidth={"100px"}>
            {row.dataCadastro ? dayjs.utc(row.dataCadastro).format("DD/MM/YYYY HH:mm") : "—"}
          </Typography>
        </TableCell>

        <TableCell>
          <Tooltip title={row.endereco || ""}>
            <Typography
              maxWidth={"150px"}
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
            >
              {row.endereco || "—"}
            </Typography>
          </Tooltip>
        </TableCell>

        <TableCell>
          <Typography
            color="error"
            component="button"
            onClick={() => setConfirmOpen(true)}
            sx={{ background: "none", border: "none", cursor: "pointer", p: 0 }}
          >
            <MdDeleteOutline fontSize={"25px"} />
          </Typography>
        </TableCell>
      </TableRow>
    </>
  );
}
